import React, { useRef } from 'react';
import { useIonRangeSlider } from '../../hooks';
import styles from './styles.css';

export default function SettingsPanel({ firstSliderSettings, secondSliderSettings, children, resetAdvancedSettings }) {
	const firstSliderRef = useRef(null);
	const secondSliderRef = useRef(null);

	useIonRangeSlider(firstSliderRef, firstSliderSettings);
	useIonRangeSlider(secondSliderRef, secondSliderSettings);

	return (
		<div className={`uk-container ${styles.wrapper}`}>
			<div className="uk-width-1-1">
				{firstSliderSettings ? (
					<div id="sliderContainer" className="idp-footer__date-picker advanced-settings">
						<label>{firstSliderSettings.title}</label>
						<div
							className={`idp-footer__range ${!secondSliderSettings ? 'idp-footer__range-full-width' : ''}`}
							id="range_1_wrapper"
						>
							<input ref={firstSliderRef} type="text" id={firstSliderSettings.id} />
						</div>
						{secondSliderSettings ? (
							<div className={`${styles.range2Wrapper}`} id="range_2_wrapper">
								<input ref={secondSliderRef} type="text" id={secondSliderSettings.id} />
							</div>
						) : null}
					</div>
				) : null}
				{children}
				<div className={`idp-footer__highlight advanced-settings ${styles.resetButtonWrapper}`}>
					<button
						className={`uk-button  ${styles.resetButton}`}
						type="button"
						onClick={(e) => {
							e.preventDefault();
							resetAdvancedSettings.onClick();
						}}
					>
						{resetAdvancedSettings.text}
					</button>
				</div>
			</div>
		</div>
	);
}
